import { FieldConfiguration } from '../../../api/ConfigApi';
import { PolicyholderProperty } from '../../../types/config';
import { EntityVisibilityDefinition } from '../../../types/entityDefinitions';
import { FieldValues, FieldValuesMap } from '../../../types/policy';

const getFieldByName = (fields: FieldConfiguration[], name: string) => {
	const found = fields.find((f) => f.name === name);
	if (!found) {
		throw new Error(`Unknown field: ${name}`);
	}
	return found;
};

export const matchParentValues = (
	parentValues: FieldValues,
	parentValuesToMatch: FieldValues,
) => parentValuesToMatch.some((val: any) => parentValues.includes(val));

export const isFieldAvailableByCondition = (
	field: FieldConfiguration,
	values: FieldValuesMap,
) => {
	return Object.keys(field.condition || {}).every((parentField) => {
		const parentValuesToMatch = field.condition[parentField];
		const parentValues = values[parentField] || [];
		return matchParentValues(parentValues, parentValuesToMatch);
	});
};

export const isFieldAvailableForDisplay = (
	fields: FieldConfiguration[],
	values: FieldValuesMap,
	name: string,
) => {
	const field = getFieldByName(fields, name);
	return isFieldAvailableByCondition(field, values);
};

export const isPolicyholderFieldVisible = (
	property: PolicyholderProperty,
	values: any,
) => {
	if (!property.visibleIf) return true;

	const visibilityDefinition: EntityVisibilityDefinition = property.visibleIf;
	const parentUri: string = visibilityDefinition.uri;
	const parentValues: FieldValues =
		values && values[parentUri] ? values[parentUri].value : [];

	return matchParentValues(parentValues, visibilityDefinition.values);
};
